module.exports = __webpack_public_path__ + "static/netflix-861da9ae2e0f5e1c7ac5715f76ffe101.png";